import { Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output, ViewChild } from '@angular/core';
// import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';
// import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { MapsAPILoader } from '@agm/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.scss']
})
export class LocationComponent implements OnInit {
  // @ViewChild("placesRef") placesRef: GooglePlaceDirective;
  // options: any = {
  //   latLng: ["-33.8688197", "151.2092955"]
  // }

  // public handleAddressChange(address: Address) {
  //   console.log(address);
  //   console.log(address.geometry.location.lat());
  //   console.log(address.geometry.location.lng());
  // }

  // constructor(){}
  // ngOnInit(): void {

  // }
  @Input() latitude: number;
  @Input() longitude: number;
  @Input() name: string;
  @Input() buildingNumber: string;
  @Input() streetName: string;
  @Input() streetNumber: string;
  @Input() locality: string;
  @Input() state: string;
  @Input() country: string;
  @Input() zipcode: string;
  @Output() onDone: any = new EventEmitter();
  @ViewChild('search') public searchElementRef: ElementRef;
  geoCoder: any;

  constructor(
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    public formBuilder: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.mapsAPILoader.load().then(() => {
      this.geoCoder = new google.maps.Geocoder();

      let autocomplete = new google.maps.places.Autocomplete(
        this.searchElementRef.nativeElement
      );
      if (this.latitude && this.longitude) {
        this.setMarker([this.longitude, this.latitude]);
        this.getAddress(this.latitude, this.longitude);
      }
      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();

          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.zoom = 15;
          this.getAddress(this.latitude, this.longitude);
        });
      });
    });
  }

  zoom: number;
  address: string;
  fetchedAddress: any;

  setMarker(location: any) {
    this.mapsAPILoader.load().then(() => {
      this.geoCoder = new google.maps.Geocoder();
      this.latitude = location.coordinates[1];
      this.longitude = location.coordinates[0];
      this.zoom = 15;
    });
  }

  getAddress(latitude: any, longitude: any) {
    this.geoCoder.geocode(
      { location: { lat: latitude, lng: longitude } },
      (results: any, status: any) => {
        if (status === 'OK') {
          if (results[0]) {
            this.zoom = 15;
            this.address = results[0].formatted_address;
            this.fetchedAddress = results[0];
            if (!this.searchElementRef.nativeElement.value)
              this.searchElementRef.nativeElement.value = this.address;
            this.getLocation()
          } else {
            window.alert('No results found');
          }
        } else {
          window.alert('Geocoder failed due to: ' + status);
        }
      }
    );
  }
  registerBuildingForm: FormGroup;

  getLocation() {
    this.name = this.findBuildingInfo('establishment')
    this.streetName = this.findBuildingInfo('route')
    this.streetNumber = this.findBuildingInfo('street_number')
    this.locality = this.findBuildingInfo('locality')
    this.state = this.findBuildingInfo('administrative_area_level_1')
    this.country = this.findBuildingInfo('country')
    this.zipcode = this.findBuildingInfo('postal_code')
  }

  findBuildingInfo(type: string) {
    if (this.fetchedAddress) {
      let addressComponents = this.fetchedAddress.address_components;
      let info = addressComponents.find((obj: any) => {
        return obj.types[0] == type;
      });

      if (info) {
        return info.long_name;
      }
    }
    return '';
  }

  onSaveHandler() {
    this.onDone.emit({
      latitude: this.latitude,
      longitude: this.longitude,
      name: this.name,
      buildingNumber: this.buildingNumber,
      streetName: this.streetName,
      streetNumber: this.streetNumber,
      locality: this.locality,
      state: this.state,
      country: this.country,
      zipcode: this.zipcode,
    })
  }

  cancel() {
    this.onDone.emit(null);
  }
}
